import { connect } from "react-redux";

import ViewerModal from "./ViewerModal";

import { selectDisplayedPages } from "~/store/selectors/page";
import {
  selectMaterialById,
  selectCurrentDlsCategory
} from "~/store/selectors/dls";
import {
  addPresentationMarker,
  updatePresentationMarker
} from "~/store/ducks/user/presentationMarkers";
import { selectIsPresentationActive } from "~/store/ducks/user/uistate";

const mapStateToProps = (state, ownProps) => ({
  activePages: selectDisplayedPages(state),
  category: selectCurrentDlsCategory(state),
  isPresentationMode: selectIsPresentationActive(state),
  material: selectMaterialById(ownProps.additionalProps.materialId)(state)
});

const mapDispatchToProps = {
  addPresentationMarker,
  updatePresentationMarker
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewerModal);
